import BaseMapper from '../../BaseMapper';

const SeasonMapper = (data, context) => {
    return data;
};

export default SeasonMapper;
